import { useEffect } from 'react'

interface SEOProps {
  title: string
  description: string
  canonical?: string
  ogImage?: string
}

export default function SEO({ title, description, canonical, ogImage = '/og-image.jpg' }: SEOProps) {
  const fullTitle = title.includes('Blossom Prime') ? title : `${title} | Blossom Prime Facility Solutions`

  useEffect(() => {
    document.title = fullTitle

    const setMeta = (selector: string, content: string) => {
      const el = document.querySelector(selector)
      if (el) el.setAttribute('content', content)
    }

    setMeta('meta[name="description"]', description)
    setMeta('meta[property="og:title"]', fullTitle)
    setMeta('meta[property="og:description"]', description)
    setMeta('meta[property="og:image"]', ogImage)
    setMeta('meta[property="twitter:title"]', fullTitle)
    setMeta('meta[property="twitter:description"]', description)
    setMeta('meta[property="twitter:image"]', ogImage)

    if (canonical) {
      const link = document.querySelector('link[rel="canonical"]')
      if (link) link.setAttribute('href', canonical)
    }
  }, [fullTitle, description, canonical, ogImage])

  return null
}
